import React, { Component } from "react";
import { Table, Button, TableHead, TableRow, TableCell, TableBody, Icon, Grid } from "@material-ui/core";
import "./MatchList.css";
import PropTypes from "prop-types";
import { prettyDates, capitalize } from "../../../../actions/utils";
import InfoPanel from "../../../Helpers/InfoPanel";
import SplitPanel from "../../../Helpers/SplitPanel";
import LinkHelper from "../../../Helpers/Link";
import { RESIDENCE_TYPES } from "../../../../constants";

import { bucketUrl } from '../../../../actions/utils'
const propertyImages = [
    require("../../../../images/png/office1.jpg"),
    require("../../../../images/png/office2.jpg"),
    require("../../../../images/png/office7.jpg"),
    require("../../../../images/png/office5.jpg"),
    require("../../../../images/png/office6.jpg"),
    require("../../../../images/png/office3.jpg")

]

const ImageFromId = (id) => {
    const parsed = parseInt("1" + id.replaceAll(/[^0-9]/g, ""))
    return propertyImages[parsed % propertyImages.length]
}

const empty = "-";

export default class PropertyMatchList extends Component {

    constructor(props) {
        super(props);
        this.mapMatch = this.mapMatch.bind(this);
    }

    translateDistance(distance) {
        if (!distance)
            return empty;
        const dist = Number(distance);
        const km = (dist / 1000);
        if (dist < 1000) {
            return `${dist} m`
        }
        else if (km >= 10) {
            return `${km.toFixed(0)} km`;
        }
        else { return `${km.toFixed(1)} km`; }
    }

    translateLocation(location) { // TODO: format location
        return empty;
    }

    translateString(str) {
        if (!str)
            return empty;
        return capitalize(str);
    }


    translateResidenceType(residenceType) {
        if (!residenceType)
            return empty;
        let result = ""
        if (typeof residenceType === "string")
            result = [RESIDENCE_TYPES.find(item => item.value === residenceType)]
        if (result === "")
            result = residenceType
                .map(type => RESIDENCE_TYPES.find(item => item.value === type))
        result = result.map(type => type ? type.displayName : undefined)
            .filter(Boolean)
            .join(", ")
        return result;
    }

    translateSize(size) {
        if (!size)
            return empty;
        return `${size} m²`;
    }

    translateRent(rent) {
        if (!rent)
            return empty;
        return `${rent} €`;
    }

    translateBigNumber(number) {
        return number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ")
    }

    translateDateRange(from, to) {
        return to
            ? (from
                ? `${prettyDates.day(from)} - ${prettyDates.day(to)}`
                : `Until ${prettyDates.day(to)}`)
            : (from
                ? `${prettyDates.day(from)} -`
                : empty)
    }

    imageWrapper(id, imageUrl) {
        const innerElement = (
            imageUrl
                ? <img className="MatchList-row-preview" src={imageUrl} alt="Preview" />
                : <Grid container justify="center" alignItems="center" className="MatchList-row-preview" style={{ width: "60px", height: "60px" }}><Icon color="secondary">home</Icon></Grid>
        )

        return id
            ? <LinkHelper to={`/user/matches/${id}`}>
                {innerElement}
            </LinkHelper>
            : <div>
                {innerElement}
            </div>
    }

    mapMatch(match) {
        // console.log('MATCH >>>', match) // DEBUG
        // const imageExists = ( match.announcement.residence.files[0] && match.announcement.residence.files[0].key );
        //TODO:Image needs to be come from backend
        const imageUrl = ImageFromId(match && match.announcement && match.announcement.properties.id)
        // const imageUrl = imageExists ? `${bucketUrl}/${match.announcement.residence.files[0].key}` : "";
        return (
            (match && match.announcement) ?
                <TableRow
                    key={match.announcement.id}
                    className="MatchList-row"
                >
                    <TableCell>
                        <div className="MatchList-row-hover-details">
                            {this.imageWrapper(!this.props.fromDashboard && match.announcement.properties.id, imageUrl)}
                        </div>
                        <div className="MatchList-row-details">
                            <Grid container direction="row" alignItems="flex-start">
                                <div className="MatchList-row-details-textarea">
                                    <img alt="Preview" src={imageUrl} style={{ float: 'left' }} />
                                    <div className="MatchList-row-details-description">
                                        {match.announcement.properties.description}
                                    </div>
                                    <SplitPanel
                                        left={
                                            <div className="MatchList-row-details-panel">
                                                <InfoPanel
                                                    compact
                                                    thin
                                                    rows={[
                                                        ["Rent (month):", this.translateRent(this.translateBigNumber(match.announcement.properties.rent))],
                                                        ["Rent (year):", this.translateRent(this.translateBigNumber(12 * match.announcement.properties.rent))],
                                                        ["Size:", this.translateSize(match.announcement.properties.size)],
                                                    ]}
                                                />
                                            </div>
                                        }
                                        right={
                                            <div className="MatchList-row-details-panel">
                                                <InfoPanel
                                                    compact
                                                    thin
                                                    rows={[
                                                        ["Type:", this.translateResidenceType(match.announcement.residence.houseType)],
                                                        ["Address:", this.translateString(match.announcement.properties.address)],
                                                        ["Distance:", this.translateDistance(match.distance)],
                                                        ["Available:", this.translateDateRange(match.announcement.properties.whenAvailable, match.announcement.properties.moveOutDate)]
                                                    ]}
                                                />
                                            </div>
                                        }
                                    />
                                </div>
                            </Grid>
                        </div>
                    </TableCell>
                    <TableCell style={{ whiteSpace: 'pre-line' }}>{match.announcement.properties.description}</TableCell>
                    <TableCell>{match.announcement.properties.address ? match.announcement.properties.address : empty} </TableCell>
                    <TableCell>{this.translateDateRange(match.announcement.properties.whenAvailable, match.announcement.properties.moveOutDate)}</TableCell>
                    <TableCell>{match.points}%</TableCell>
                    {/* <TableCell><Icon className={match.personPoints ? "MatchList-row-personality-match" : "MatchList-row-personality"}>{match.personPoints < 3 ? "tag_faces" : ""}</Icon></TableCell> */}
                    <TableCell>
                        <Icon
                            className={match.favorite ? "MatchList-row-icon-favorite" : "MatchList-row-icon"}
                            onClick={() => {
                                if (this.props.setFavorite)
                                    this.props.setFavorite(match.announcement.id, !match.favorite)
                            }}
                        >
                            {match.favorite ? "favorite" : "favorite_border"}
                        </Icon>
                    </TableCell>
                </TableRow> : <h1>Error</h1>
        );
    }

    render() {
        const { matches } = this.props;
        return (

            <Table>

                <colgroup>
                    <col width="10%" />{/* Property */}
                    <col width="25%" />{/* Description */}
                    <col width="20%" />{/* Location */}
                    <col width="15%" />{/* Available time */}
                    <col width="15%" />{/* Match with property */}
                    <col width="5%" />{/* Favorite */}
                </colgroup>

                <TableHead>
                    <TableRow>
                        <TableCell style={{ fontWeight: 'bold' }}>Property</TableCell>
                        <TableCell style={{ fontWeight: 'bold' }}>Description</TableCell>
                        <TableCell style={{ fontWeight: 'bold' }}>Location</TableCell>
                        <TableCell style={{ fontWeight: 'bold' }}>Available time</TableCell>
                        <TableCell style={{ fontWeight: 'bold' }}>Match with property</TableCell>
                        { /*<TableCell>Match with landlord</TableCell>*/}
                        <TableCell style={{ fontWeight: 'bold' }}>Favorite</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {/* <TableRow/> */}
                    {matches ? matches.map(this.mapMatch) : undefined}
                </TableBody>
            </Table>

        );
    }

}

PropertyMatchList.propTypes = {
    setFavorite: PropTypes.func.isRequired,
    matches: PropTypes.array.isRequired
}